var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
var gutter = 8;
var ButtonGroup = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n\n  button + button {\n    margin-left: ", "px;\n  }\n"], ["\n  display: inline-flex;\n\n  button + button {\n    margin-left: ", "px;\n  }\n"])), gutter);
ButtonGroup.displayName = 'ButtonGroup';
export default ButtonGroup;
var templateObject_1;
//# sourceMappingURL=button-group.js.map